<template>
  <div>
    <div class="form-card">
      <h3 class="form-card-title">
        <span class="title-text">
          {{
          Getter_User_Info.pwdStatus === 1 ? $t('labels.acc.loginPwd.update') : $t('labels.acc.loginPwd.set')
          }}
        </span>
        <!--<span class="explain">
          <i class="star">*</i>
          {{ $t('labels.acc.loginPwd.desc') }}
        </span>-->
      </h3>
      <ValidationObserver ref="validate">
        <div class="form-card-body">
          <div class="form">
            <p class="color-error mb-10" v-if="Getter_User_Info.gaStatus === 0">
              {{ $t('labels.acc.ga.txt.1') }}
              <router-link
                to="/usercenter/google-verification-bind"
                class="text-bold color-error"
              >{{ $t('labels.acc.ga.setup') }}</router-link>
            </p>
            <div v-if="Getter_User_Info.pwdStatus === 1">
              <div class="form-group">
                <TextFieldComponent
                  ref="oldPassword"
                  type="password"
                  :model.sync="form.oldPassword"
                  :label="$t('labels.acc.loginPwd.oldPwd')"
                  :outlined="true"
                  :rules="{ ...rules.oldPassword, not_same: form.newPassword }"
                ></TextFieldComponent>
              </div>
              <div class="form-group">
                <TextFieldComponent
                  ref="newPassword"
                  type="password"
                  :model.sync="form.newPassword"
                  :label="$t('labels.acc.loginPwd.newPwd')"
                  :outlined="true"
                  :rules="rules.newPassword"
                  :vid="'newPassword'"
                ></TextFieldComponent>
              </div>
              <div class="form-group">
                <TextFieldComponent
                  ref="repwd"
                  type="password"
                  :model.sync="form.repwd"
                  :label="$t('labels.acc.loginPwd.confirmNewPwd')"
                  :outlined="true"
                  :rules="{ ...rules.repwd, confirmed: 'newPassword' }"
                ></TextFieldComponent>
              </div>
            </div>
            <div v-else>
              <div class="form-group">
                <TextFieldComponent
                  ref="password"
                  type="password"
                  :model.sync="form.password"
                  :label="$t('labels.acc.loginPwd')"
                  :outlined="true"
                  :rules="rules.password"
                  :vid="'password'"
                ></TextFieldComponent>
              </div>
              <div class="form-group">
                <TextFieldComponent
                  ref="repwd"
                  type="password"
                  :model.sync="form.repwd"
                  :label="$t('labels.acc.loginPwd.confirmPwd')"
                  :outlined="true"
                  :rules="{ ...rules.repwd, confirmed: 'password' }"
                ></TextFieldComponent>
              </div>
            </div>

            <div class="form-group" v-if="Getter_User_Info.gaStatus === 1">
              <TextFieldComponent
                ref="gaCode"
                type="password"
                :model.sync="form.gaCode"
                :label="$t('labels.gaCode')"
                :outlined="true"
                :rules="rules.gaCode"
              ></TextFieldComponent>
            </div>
            <div class="form-group">
              <v-btn
                class="commit-btn"
                depressed
                :class="{ disabled: Getter_User_Info.gaStatus === 0 || committing }"
                :disabled="Getter_User_Info.gaStatus === 0"
                :loading="committing"
                @click="submitBtnClick"
              >{{Getter_User_Info.pwdStatus === 1 ? $t('actions.modify') : $t('actions.setup')}}</v-btn>
            </div>
            <div
              class="color-error"
              style="font-size: 12px; margin-top: 5px;"
            >*{{$t('v.common.pwd.pwdValid.note')}}</div>
          </div>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import VerifyBtn from '@/components/VerifyBtn/VerifyBtn';
import { mapGetters } from 'vuex';
import { accountManagementApi } from '@/api/user/accountManagementApi';
import { getErrorLabelMixin } from '@/common/mixin/getErrorLabel';
import { getterTypes } from '@/store/getter-types';
import TextFieldComponent from '@/components/Form/TextField';

export default {
  name: 'LoginPwdBind',
  mixins: [getErrorLabelMixin],
  components: {
    VerifyBtn,
    TextFieldComponent
  },
  data() {
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        repwd: '',
        password: '',
        // validateCode: '',
        gaCode: ''
      },
      rules: {
        oldPassword: {
          required: true
        },
        newPassword: {
          required: true,
          regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\s\S]{6,20}$/
        },
        repwd: {
          required: true,
          regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\s\S]{6,20}$/
        },
        password: {
          required: true,
          regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\s\S]{6,20}$/
        },
        gaCode: {
          required: true,
          numeric: true,
          length: 6
        }
      },
      isSetPwd: false,
      isModifyPwd: false,
      committing: false
    };
  },
  computed: {
    ...mapGetters([getterTypes.Getter_User_Info]),
    errorMsgs() {
      // let validateCodeRequired = this.Getter_User_Info.registerType === 1 ? '请输入手机验证码' : '请输入邮箱验证码';
      // let validateCodeError = this.Getter_User_Info.registerType === 1 ? '手机验证码格式不正确' : '邮箱验证码格式不正确';
      return {
        oldPassword: {
          required: this.$t('v.common.oldPwd.required'),
          pwdValid: null
        },
        newPassword: {
          required: this.$t('v.common.newPwd.required'),
          pwdValid: this.$t('v.common.pwd.pwdValid')
        },
        repwd: {
          required: this.$t('v.common.secondPwd.required'),
          sameAs: this.$t('v.common.secondPwd.sameAs')
        },
        password: {
          required: this.$t('v.common.pwd.required'),
          pwdValid: this.$t('v.common.pwd.pwdValid')
        },
        // validateCode: {
        //   required: validateCodeRequired,
        //   verifyCode: validateCodeError,
        // },
        gaCode: {
          required: this.$t('v.common.gaCode.required'),
          gaCode: this.$t('v.common.gaCode.format')
        }
      };
    }
  },
  created() {
    if (this.Getter_User_Info.pwdStatus === 1) {
      this.isModifyPwd = true;
    } else if (this.Getter_User_Info.pwdStatus === 0) {
      this.isSetPwd = true;
    }
  },
  methods: {
    async submitBtnClick() {
      if (this.Getter_User_Info.gaStatus === 0) {
        this.errorNotify(this.$t('v.common.ga.setup'));
        return;
      }

      let validated = await this.$refs.validate.validate();
      if (!validated || this.committing) {
        return;
      }

      this.committing = true;

      let data = {
        ...this.form
      };
      delete data.repwd;
      if (this.Getter_User_Info.pwdStatus === 0) {
        this._requestSetPwd(data);
      } else if (this.Getter_User_Info.pwdStatus === 1) {
        this._requestModifyPwd(data);
      }
    },
    _requestSetPwd(data) {
      delete data.oldPassword;
      delete data.newPassword;
      accountManagementApi
        .setLoginPwd(data)
        .then(res => {
          this.committing = false;
          if (res.errcode === 0) {
            this.successNotify(this.$t('success.loginPwd.set'));
            this.$router.replace({ name: 'account-management' });
          }
        })
        .catch(() => {
          this.committing = false;
        });
    },
    _requestModifyPwd(data) {
      delete data.password;
      accountManagementApi
        .modifyLoginPwd(data)
        .then(res => {
          this.committing = false;
          if (res.errcode === 0) {
            this.successNotify(this.$t('success.loginPwd.modify'));
            this.$router.replace({ name: 'account-management' });
          }
        })
        .catch(() => {
          this.committing = false;
        });
    }
  }
};
</script>

<style src="@/common/styles/mixin/account-bind.scoped.styl" lang="stylus" scoped></style>
<style lang="stylus" scoped>
@import 'login-pwd-bind.scoped.styl';
</style>
